exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footerHaut[data-v-2e48bd7a]{background-color:#5894b4}.icoFooterHaut[data-v-2e48bd7a]{color:#c5e0dc;font-size:xx-large}.textFooterHaut[data-v-2e48bd7a]{color:#fff;font-weight:500;font-size:large}.footerBas[data-v-2e48bd7a]{background-color:#002969}.imgFooter[data-v-2e48bd7a]{width:90px}.textFooterBas[data-v-2e48bd7a]{color:#fff;font-weight:500;font-size:small}.textFooterBas[data-v-2e48bd7a],.textFooterBas[data-v-2e48bd7a]:hover{text-decoration:none;outline:none}.text-decoration-none[data-v-2e48bd7a]{text-decoration:none!important}", ""]);

// exports
